export default {
  content: ''+
  '<div class="text-box">'+
  '<h3 class="h3-line">1.	无人机系统建模</h3>'+
  '<p class="text-line">无人机系统建模采用系统建模语言SysML来实现。</p>'+
  '<p class="text-line">SysML语言是对象管理组织OMG 决定在UML2.0 的子集进行重用和扩展的基础上提出一种新的系统建模语言——SysML(Systems Modeling Language)，作为系统工程的标准建模语言。和UML 用来统一软件工程中使用的建模语言一样，SysML 的目的是统一系统工程中使用的建模语言。</p>'+
  '<p class="text-line">SysML 为系统的结构模型、行为模型、需求模型和参数模型定义了语义。</p>'+
  '<h3 class="h3-line">2.	无人机系统组成模型</h3>'+
  '<p class="text-line">无人机系统组成使用模块定义图（Block Define Diagram, BDD）模型来表达。BDD图是一种结构图，它主要对系统的结构组成以及组成元素间的关系进行描述。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t5-new.jpg" width="100%" />' +
  '<h3 class="h3-line">3.	无人机系统部件间的关系模型</h3>'+
  '<p class="text-line">无人机系统部件间的关系与接口使用内部模块图（Internal Block Diagram，IBD）模型来表达。IBD图用来表达单个模块内部的结构以及一个模块内部组件的关系和接口。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t6-new.jpg" width="100%" />' +
  '<h3 class="h3-line">4.	无人机系统的参数模型</h3>'+
  '<p class="text-line">无人机系统组件间的参数约束关系采用参数图来表达。参数图（Parametric Diagrams）被用来生成可以约束模块的属性的方程组。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t7-new.jpg" width="100%" />' +
  '<h3 class="h3-line">5.	无人机机械建模</h3>'+
  '<p class="text-line">以固定翼无人机为例，机体采用水滴流线造型，大展弦比机翼，带翼梢小翼以改善升力，将水平尾翼和垂直尾翼改款成为V字造型的垂尾，满足水平和垂直两个方向的作动需求。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t8.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">5.1 飞控盒数字孪生体模型</h3>'+
  '<img class="img-line" src="/work/static/img/uva/design/t9.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">5.2机翼数字孪生体模型</h3>'+
  '<p class="text-line">机翼（包含尾翼）提供飞机大部分升力，并由内副翼、外副翼、方向舵等作动面提供飞机操控需求。机翼内部可能有油箱，有武器下挂架，可以下挂作战武器。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t10.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">5.3机体数字孪生体模型</h3>'+
  '<p class="text-line">机身是无人机的主要组成部分，承担飞机的装配基准和主要装载需求。机身分为四个部分：空速管、前机身、中机身和机身尾段。</p>'+
  '<p class="text-line">空速管位于机身前段，除了测量飞行速度之外，还有感受气流的总压（也称全压）和静压等作用。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t11.jpg" width="100%" />' +
  '<p class="text-line">机身是无人机的主要组成部分，承担飞机的装配基准和主要装载需求。机身分为四个部分：空速管、前机身、中机身和机身尾段。</p>'+
  '<p class="text-line">空速管</p>'+
  '<p class="text-line">空速管位于机身前段，除了测量飞行速度之外，还有感受气流的总压（也称全压）和静压等作用。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t12.jpg" width="100%" />' +
  '<p class="text-line">机身前段</p>'+
  '<p class="text-line">机身前段保证飞机造型，并作为空速管、主起的安装面，内置机载雷达等部件。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t13.jpg" width="100%" />' +
  '<p class="text-line">机身中段、尾段</p>'+
  '<p class="text-line">机身中段连接机身前段和后段，并提供机翼、后起的安装基准。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t14.jpg" width="100%" />' +
  '<p class="text-line">尾段有进气口，内装发动机，值得注意的是其进气口在机体上方，和翼龙有所区别；并提供V型尾翼和腹鳍的安装基准。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t15.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">5.4动力系统数字孪生体模型</h3>'+
  '<p class="text-line">螺旋桨通过转轴连接飞机发动机，将发动机传递的扭矩，转化为推力，以提供飞机向前所需动力。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t16.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">5.5起落架系统数字孪生体模型</h3>'+
  '<p class="text-line">起落架采用前三点式布置，前主起包括作动筒、压缩筒和机轮部分，后起包括机轮和机架。</p>'+
  '<img class="img-line" src="/work/static/img/uva/design/t17.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">5.6传感器盒数字孪生体模型</h3>'+
  '<img class="img-line" src="/work/static/img/uva/design/t18.jpg" width="100%" />' +
  '<h3 class="h3-line">6.	在ModelStudio中完成无人机机械模型组装</h3>'+
  '<h3 class="h3-sub-line">6.1机械模型装配</h3>'+
  '<img class="img-line" src="/work/static/img/uva/design/t19.jpg" width="100%" />' +
  '<h3 class="h3-sub-line">6.2数字孪生虚拟实验室</h3>'+
  '<img class="img-line" src="/work/static/img/uva/design/t20.jpg" width="100%" />' +
  '<h3 class="h3-line">7.	无人机算法建模</h3>'+
  '<p class="text-line">自动飞行系统可以实现飞机三轴姿态角、垂直和水平航迹、空速、高度的控制与稳定。</p>'+
  '<h3 class="h3-line">7.1典型无人机飞行控制模型</h3>'+
  '<img class="img-line" src="/work/static/img/uva/design/t21.jpg" width="100%" />' +
  '<h3 class="h3-line">7.2无人机横向飞行控制模型</h3>'+
  '<img class="img-line" src="/work/static/img/uva/design/t22.jpg" width="100%" />' +
  '</div>'
}